module.exports = __webpack_public_path__ + "img/shenhese.fa20b152.png";